import { withLoginUser } from 'src/api/user'
import { RequestBoxLayout } from './RequestBoxLayout'

export const RequestBoxPage = withLoginUser(({ user }) => {
  return <RequestBoxLayout user={user} />
})
